export const PRICING_TABLE_FREE = 'pricing-table-free' as const
export const PRICING_TABLE_PLUS = 'pricing-table-plus' as const
export const PRICING_TABLE_STUDY_PACK = 'pricing-table-plus-study-pack' as const
export const CHECK = 'CHECK' as const

export const CITATION_STYLE = 'citationStyle'
export const GRAMMAR_CHECKS = 'grammarChecks'
export const SAVE_CITATIONS = 'saveCitations'
export const PLAGIARISM_DETECTION = 'plagiarismDetection'
export const EXPERT_PAPER_HELP = 'expertPaperHelp'
export const EXPERT_HOMEWORK_HELP = 'expertHomeworkHelp'
export const TEXTBOOK_SOLUTIONS = 'textbookSolutions'
export const PRACTICE_PROBLEMS = 'practiceProblems'
export const MATH_SOLVER = 'mathSolver'
export const FREE_ACCOUNT = 'free account'
export const PLUS_FREE_TRIAL = 'Plus 3-day free trial'
export const CHEGG_STUDY_PACK = 'Chegg Study Pack'
export const ADD_FREE_EXPERIENCE = 'adFreeExperience'
export const PRODUCT_VALUE_MAP = {
  [PRICING_TABLE_FREE]: FREE_ACCOUNT,
  [PRICING_TABLE_PLUS]: PLUS_FREE_TRIAL,
  [PRICING_TABLE_STUDY_PACK]: CHEGG_STUDY_PACK,
}
